import * as React from "react";

const IconUser: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="15" viewBox="0 0 13 15" fill="currentColor">
            <path
                fill="currentColor"
                d="M596.875,1210.75 C598.808203,1210.75 600.375,1209.18293 600.375,1207.25 C600.375,1205.31707 598.808203,1203.75 596.875,1203.75 C594.941797,1203.75 593.375,1205.31707 593.375,1207.25 C593.375,1209.18293 594.941797,1210.75 596.875,1210.75 Z M598.261328,1212.0625 L595.488672,1212.0625 C592.872148,1212.0625 590.75,1214.18438 590.75,1216.80117 C590.75,1217.32453 591.174375,1217.74918 591.697734,1217.74918 L602.052813,1217.74918 C602.576172,1217.75 603,1217.32617 603,1216.80117 C603,1214.18438 600.878125,1212.0625 598.261328,1212.0625 Z"
                transform="translate(-590 -1203)"
            />
        </svg>
    );
};

export default React.memo(IconUser);
